import MobileOnlyLink from '@acorn-portal/shared/src/components-v2/mobile-only-link';
import { Typography } from '@mui/material';

const CancellationReasonInfoText = ({ contactNumber }: { contactNumber: string }) => {
	return (
		<Typography>
			If you need to cancel for any other reason then please call us
			{contactNumber ? (
				<>
					{' '}
					on <MobileOnlyLink href={`tel:${contactNumber}`} text={contactNumber} />
				</>
			) : null}
			.
		</Typography>
	);
};

export default CancellationReasonInfoText;
